// RAS-57: Constantes geo centralisees pour unifier le rayon de recherche
export const GEO = {
  DEFAULT_RADIUS_KM: 10,
  MAX_RADIUS_KM: 15,
};
